import { render, staticRenderFns } from "./VerifyContact.vue?vue&type=template&id=35900093&scoped=true"
import script from "./VerifyContact.vue?vue&type=script&lang=js"
export * from "./VerifyContact.vue?vue&type=script&lang=js"
import style0 from "./VerifyContact.vue?vue&type=style&index=0&id=35900093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35900093",
  null
  
)

export default component.exports